import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { Radio } from "@mui/material";

class WinterMaintenceModeSwitcher extends Component {
  render() {
    const { isReportMode, onSetRouteOrReportMode } = this.props;

    return null;

    return (
      <div className={styles.modeSwitcherContainer}>
        <div style={{ marginRight: "15px" }}>
          <Radio
            className={styles.MuiRadio_resolve}
            checked={!isReportMode}
            size="small"
            onClick={() => {
              onSetRouteOrReportMode(false);
            }}
          />
          <span> Маршруты</span>
        </div>
        <div>
          <Radio
            className={styles.MuiRadio_resolve}
            checked={isReportMode}
            size="small"
            onClick={() => {
              onSetRouteOrReportMode(true);
            }}
            style={{ padding: "0px !important" }}
          />
          <span> Отчет о наличии и выходе на линию ТС в интервале не более часа</span>
        </div>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceModeSwitcher));
